// extracted by mini-css-extract-plugin
export default {"crop":"crop_crop__csABv","crop_ReactCrop":"crop_crop_ReactCrop__AWz02"};